export var checkIsExternalLink = function (url) {
    var urlPattern = new RegExp('^http', 'i');
    return urlPattern.test(url);
};
